import React, { useEffect } from 'react';
import Navbar from './components/Navbar';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Home from './components/Home';
import Dashboard from './components/Dashboard';
import Account from './components/Account';
import Reports from './components/Reports';
import Login from './components/Login';
import PrivateRoute from './PrivateRoute'; // Ensure this handles authentication
import { AuthProvider } from './AuthContext'; // Import AuthProvider
import Admin from './components/Admin';
import Kiosk from './components/Kiosk';
import ImportantInfo from './components/ImportantInfo';
import CardiacArrestTimer from './components/codeTimer';
import Resources from './components/Resources';
import PasswordReset from './components/PasswordReset';
import ClassReport from './components/ClassReport';
import Directory from './components/Directory';
import Chat from './components/Chat/Chat';
import PhoneBook from './components/PhoneBook';
import ExpirationList from './components/ExpirationList';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { requestNotificationPermission } from './services/notificationService';

const theme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#1976d2',
    },
    secondary: {
      main: '#dc004e',
    },
  },
});

const App = () => {
    useEffect(() => {
        // Request notification permission when the app starts
        requestNotificationPermission()
            .then((token) => {
                if (token) {
                    console.log('FCM Token:', token);
                }
            })
            .catch((err) => {
                console.error('Error requesting notification permission:', err);
            });
    }, []);

    return (
        <AuthProvider>
            <ThemeProvider theme={theme}>
                <CssBaseline />
                <Router>
                    <Navbar />
                    <Routes>
                        {/* Public Routes */}
                        <Route path='/login' element={<Login />} />
                        <Route path='/' element={<Dashboard />} />
                        <Route path='/kiosk' element={<Kiosk />} />
                        <Route path='/codeTimer' element={<CardiacArrestTimer />} />
                        <Route path='/dashboard' element={<PrivateRoute component={Dashboard} />} />
                        <Route path="*" element={<Navigate to="/login" />} />
                        <Route path='/PasswordReset' element={<PasswordReset />} />

                        
                        {/* Protected Routes */}
                        <Route path='/account' element={<PrivateRoute component={Account} />} />
                        <Route path='/reports' element={<PrivateRoute component={Reports} />} />
                        <Route path='/admin' element={<PrivateRoute component={Admin} />} />
                        <Route path='/importantinfo' element={<PrivateRoute component={ImportantInfo} />} />
                        <Route path='/phonebook' element={<PrivateRoute component={PhoneBook} />} />
                        <Route path='/resources' element={<PrivateRoute component={Resources} />} />
                        <Route path='/ClassReport' element={<PrivateRoute component={ClassReport} />} />
                        <Route path='/directory' element={<Directory />} />
                        <Route path='/chat' element={<PrivateRoute component={Chat} />} />
                        <Route path='/expiration-list' element={<PrivateRoute component={ExpirationList} />} />
                        {/* Redirect to home if no matching route */}
                        <Route path="*" element={<Navigate to="/" />} />
                    </Routes>
                </Router>
            </ThemeProvider>
        </AuthProvider>
    );
};

export default App;
